<script>
import { BBreadcrumb } from 'bootstrap-vue'

export default {
  name: 'AppHeader',
  
  components: {
    BBreadcrumb
  },
  
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    slotBtnPosition: {
      type: String,
      default: "end",
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col">
        <b-breadcrumb :items="items" class="mb-0 font-size-12"></b-breadcrumb>
      </div>
    </div>
    <div class="row mb-3 mt-2">
      <div class="col-xl-4 d-flex align-items-center">
        <div class="mb-1">
          <span class="mb-0 font-size-22 fw-semibold" style="line-height:20px">{{ title }}</span>
        </div>
      </div>

      <div class="col">
        <div 
          :class="[
            slotBtnPosition === 'start' ? 'justify-content-start' : 'justify-content-end',
          ]"
          class="d-flex align-items-center">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>